import '../kickpoint-core/js/kp-menus.js'
import '../kickpoint-core/js/kp-main-script.js';
import '../kickpoint-core/js/kp-filter-posts.js';
import '../kickpoint-core/js/kp-swiper-gallery.js';
import '../kickpoint-core/js/kp-swiper-carousel.js';
import '../kickpoint-core/js/kp-swiper-testimonials.js';
import '../kickpoint-core/js/kp-timeline.js';
import '../kickpoint-core/js/kp-feature-video.js';
import '../kickpoint-core/js/kp-accordions.js';
import '../kickpoint-core/js/kp-staggered-content.js';
import '../kickpoint-core/js/kp-video.js';
import '../kickpoint-core/js/kp-lazyframe.js';
import '../kickpoint-core/js/kp-announcement-bar.js';
import '../kickpoint-core/js/kp-forms.js';
import '../kickpoint-core/js/kp-tables.js';
// import '../kickpoint-core/js/kp-franchise-contact-form.js';
import '../kickpoint-core/js/kp-bin-sizes.js';

import 'swiper/css';
import 'lazyframe/dist/lazyframe.css';

const importAll = (r) => r.keys().forEach(r)
importAll(require.context('./icons/', true, /\.svg$/))